export enum HomeActionType {
  GET_DEMAND_HOME_FAILURE = '@@home/GET_DEMAND_HOME_FAILURE',
  GET_DEMAND_HOME_REQUEST = '@@home/GET_DEMAND_HOME_REQUEST',
  GET_DEMAND_HOME_SUCCESS = '@@home/GET_DEMAND_HOME_SUCCESS',

  GET_SUPPLY_HOME_FAILURE = '@@home/GET_SUPPLY_HOME_FAILURE',
  GET_SUPPLY_HOME_REQUEST = '@@home/GET_SUPPLY_HOME_REQUEST',
  GET_SUPPLY_HOME_SUCCESS = '@@home/GET_SUPPLY_HOME_SUCCESS',
}
